function authHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
  };
}

export async function getDefaultPage(): Promise<string | null> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/defaultpage`, {
      headers: authHeaders(),
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json?.data?.defaultPath ?? null;
  } catch {
    return null;
  }
}

export async function setDefaultPage(defaultPath: string, defaultName?: string): Promise<boolean> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/defaultpage`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ defaultPath, defaultName: defaultName ?? '' }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function clearDefaultPage(): Promise<boolean> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/defaultpage`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function getHiddenMenuItems(): Promise<string[]> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/hiddenmenuitems`, {
      headers: authHeaders(),
    });
    if (!res.ok) return [];
    const json = await res.json();
    const raw: string = json?.data?.hiddenMenuItems ?? '';
    return raw ? raw.split(',').map((s: string) => s.trim()).filter(Boolean) : [];
  } catch {
    return [];
  }
}

export async function getPinnedMenuItems(): Promise<string[] | null> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/pinnedmenuitems`, {
      headers: authHeaders(),
    });
    if (!res.ok) return null;
    const json = await res.json();
    const raw: string = json?.data?.pinnedMenuItems ?? '';
    return raw ? raw.split(',').map((s: string) => s.trim()).filter(Boolean) : [];
  } catch {
    return null;
  }
}

export async function setPinnedMenuItems(items: string[]): Promise<boolean> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/pinnedmenuitems`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ pinnedMenuItems: items.join(',') }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function getDigitalTeamMembers(): Promise<string[] | null> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/digitalteammembers`, {
      headers: authHeaders(),
    });
    if (!res.ok) return null;
    const json = await res.json();
    const raw: string = json?.data?.digitalTeamMembers ?? '';
    return raw ? raw.split(',').map((s: string) => s.trim()).filter(Boolean) : [];
  } catch {
    return null;
  }
}

export async function setDigitalTeamMembers(ids: string[]): Promise<boolean> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/digitalteammembers`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ digitalTeamMembers: ids.join(',') }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function setHiddenMenuItems(items: string[]): Promise<boolean> {
  try {
    const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/userpreferences/hiddenmenuitems`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ hiddenMenuItems: items.join(',') }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
